import classNames from "classnames";
import React from "react";
import ReactPlayer from "react-player";

import AudioIcon from "../../../../images/audioIcon.svg";
import defaultThumbNail from "../../../../images/defaulThumb.png";
import commonStyles from "../../style.module.css";
import styles from "./style.module.css";

const VideoPlayer = ({
  playerRef,
  className = "",
  url,
  style = { height: "100%", width: "auto" },
  height = "100%",
  width = "auto",
  isContextMenuEnabled = true,
  crossOrigin = "",
  controlsList = "nodownload",
  aspectRatio = "16:9",
  controls = true,
  playing = true,
  loop = true,
  poster = defaultThumbNail,
  isAudio = false,
  onPlayPause,
  progressInterval = 1000, // 1000ms is ReactPlayer default
  subtitleTracks = [],
  isPosterVisible = true,
  showTransitionOverlay = false,
  isTransitioning = false,
  transitionName = "",
  ...rest
}) => {
  const aspectRatioClasses = {
    [commonStyles.aspectRatioSixteenXNine]: aspectRatio === "16:9",
    [commonStyles.aspectRatioNineXSixteen]: aspectRatio === "9:16",
    [commonStyles.aspectRatioNineXEighteen]: aspectRatio === "9:18",
    [commonStyles.aspectRatioThreeXFour]: aspectRatio === "3:4",
    [commonStyles.aspectRatioFourXThree]: aspectRatio === "4:3",
    [commonStyles.aspectRatioOneXOne]: aspectRatio === "1:1",
    [commonStyles.aspectRatioFourXFive]: aspectRatio === "4:5",
  };

  return (
    <>
      <ReactPlayer
        {...rest}
        ref={playerRef}
        style={style}
        className={classNames(styles.container, className, aspectRatioClasses)}
        url={url}
        width={width}
        height={height}
        controls={controls}
        playing={playing}
        loop={loop}
        {...(onPlayPause && typeof onPlayPause === "function"
          ? { onPlay: () => onPlayPause(true), onPause: () => onPlayPause(false) }
          : {})}
        progressInterval={progressInterval}
        config={{
          file: {
            attributes: {
              controlsList,
              ...(isPosterVisible
                ? {
                    poster: !isAudio ? poster : AudioIcon,
                  }
                : {}),
              disablePictureInPicture: true,
              ...(crossOrigin && { crossOrigin }),
              ...(isContextMenuEnabled
                ? {
                    onContextMenu: (e) => e.preventDefault(),
                  }
                : {}),
            },
            ...(!!subtitleTracks?.length
              ? {
                  tracks: subtitleTracks,
                }
              : {}),
          },
        }}
      />

      {isTransitioning && showTransitionOverlay ? (
        <div
          className={classNames(styles.transitionOverlay, aspectRatioClasses)}
          style={{ backgroundImage: `url(${poster})` }}
        >
          <div className={styles.transitionIconContainer}>
            <span className={styles.transitionLabel}>{transitionName}</span>
          </div>
        </div>
      ) : null}
    </>
  );
};

export default VideoPlayer;
